import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6"},[(_vm.back)?_c(VBtn,{attrs:{"to":_vm.back.to,"large":"","outlined":""},domProps:{"innerHTML":_vm._s(_vm.back.title)}}):_vm._e(),(_vm.forward)?_c(VBtn,{staticClass:"float-right",attrs:{"to":_vm.forward.to,"large":"","outlined":""},domProps:{"innerHTML":_vm._s(_vm.forward.title)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }